import React from "react";

/**
 * Идеально концентрические три «разорванных» кольца.
 * @param {number} size - размер (px)
 * @param {number} gapRatio - доля дуги (0..1), например 0.7 = 70% видимой дуги, 30% зазор
 */
const TripleSpinner = ({ size = 32, gapRatio = 0.72 }) => {
    // Радиусы и толщины в координатах viewBox (0..100)
    const tOuter = 8;   // толщина внешнего
    const tMid   = 6;   // толщина среднего
    const tInner = 5;   // толщина внутреннего

    const rOuter = 45 - tOuter / 2;
    const rMid   = 32 - tMid   / 2;
    const rInner = 22 - tInner / 2;

    const cOuter = 2 * Math.PI * rOuter;
    const cMid   = 2 * Math.PI * rMid;
    const cInner = 2 * Math.PI * rInner;

    const dashOuter = cOuter * gapRatio;
    const gapOuter  = cOuter - dashOuter;

    const dashMid = cMid * gapRatio;
    const gapMid  = cMid - dashMid;

    const dashInner = cInner * gapRatio;
    const gapInner  = cInner - dashInner;

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 100 100"
            style={{ display: "block" }}
            aria-label="loading"
        >
            {/* Внешнее кольцо — зелёное — по часовой */}
            <g className="spin-cw" style={{ animationDuration: "1s" }}>
                <circle
                    cx="50" cy="50" r={rOuter}
                    fill="none"
                    stroke="var(--bs-success, #198754)"
                    strokeWidth={tOuter}
                    strokeLinecap="round"
                    strokeDasharray={`${dashOuter} ${gapOuter}`}
                />
            </g>

            {/* Среднее кольцо — красное — против часовой */}
            <g className="spin-ccw" style={{ animationDuration: "0.85s" }}>
                <circle
                    cx="50" cy="50" r={rMid}
                    fill="none"
                    stroke="var(--bs-danger, #dc3545)"
                    strokeWidth={tMid}
                    strokeLinecap="round"
                    strokeDasharray={`${dashMid} ${gapMid}`}
                />
            </g>

            {/* Внутреннее кольцо — жёлтое — по часовой */}
            <g className="spin-cw" style={{ animationDuration: "0.65s" }}>
                <circle
                    cx="50" cy="50" r={rInner}
                    fill="none"
                    stroke="var(--bs-warning, #ffc107)"
                    strokeWidth={tInner}
                    strokeLinecap="round"
                    strokeDasharray={`${dashInner} ${gapInner}`}
                />
            </g>
        </svg>
    );
};

export default TripleSpinner;
